import { Box } from '@mui/material';
import { ComposeSocialPublishView } from './ComposeSocialPublishView';

/**
 * Publish tab for a composition: social platforms only (no external delivery).
 */
export function ComposePublishView() {
  return (
    <Box sx={{ maxWidth: 'md' }}>
      <ComposeSocialPublishView />
    </Box>
  );
}
